import { render } from "./chair-indicator.vue?vue&type=template&id=593b33e8&scoped=true"
import script from "./chair-indicator.vue?vue&type=script&lang=js"
export * from "./chair-indicator.vue?vue&type=script&lang=js"

import "./chair-indicator.vue?vue&type=style&index=0&id=593b33e8&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-593b33e8"]])

export default __exports__